export default "__VITE_ASSET__C1Ry7IU5__"